<template>
	<el-card class="chefDevice">
		<div class="clearfloat actBar">
			<el-button
				type="primary"
				class="left"
				v-if="btnPer('sta_outputDeviceList')"
				size="mini"
				@click="handleExport"
			>
				批量导出
			</el-button>
			<search
				class="right searchBar"
				:right="true"
				:searchList="searchList"
				:searchParams="searchParams"
				formName="searchParams"
				@resetForm="resetForm"
				@submitForm="submitForm"
			></search>
		</div>

		<table-page
			class="table"
			:page="tableFilter.page"
			:limit="tableFilter.pageSize"
			:tableDable="tableData"
			:columns="columns"
			@handleSelectionChange="handleSelectionChange"
			:selection="true"
		></table-page>
		<pagination
			v-show="total > 0"
			:total="total"
			:page.sync="tableFilter.pageNumber"
			:limit.sync="tableFilter.pageSize"
			@pagination="getDeviceList"
		/>
	</el-card>
</template>

<script>
import tablePage from "@/components/standard/table.vue";
import search from "@/components/standard/searchList.vue";
import pagination from "@/components/standard/pagination.vue";
import { Message } from "element-ui";
export default {
	data() {
		return {
			searchList: [
				{
					label: "MAC/SN",
					prop: "macSn",
					type: "input",
				},
				{
					label: "产品型号",
					prop: "productId",
					type: "select",
					options: [],
				},
				{
					label: "品牌",
					prop: "brand",
					type: "select",
					options: this.$store.state.standard.brands,
				},
				{
					label: "网络连接状态",
					prop: "online",
					type: "select",
					options: [
						{
							label: "在线",
							value: 1,
						},
						{
							label: "离线",
							value: 0,
						},
					],
				},
				{
					label: "激活日期",
					prop: "activeTime",
					type: "datetimerange",
					startName: "激活开始日期",
					endName: "激活结束日期",
				},
			],
			selectArry: [],
			searchParams: {
				macSn: null,
				productId: null,
				online: null,
				activeTime: null,
			},
			columns: [
				{
					prop: "mac",
					label: "MAC地址",
					align: "center",
					width: "100",
				},
				{
					prop: "sn",
					label: "SN序列号",
					align: "center",
					showOverflow: true,
					width: "100",
				},
				{
					prop: "product",
					label: "产品类型",
					align: "center",
					render: (h, params) => {
						return h("span", params.row.productType.productType);
					},
				},
				{
					prop: "productModel",
					label: "产品型号",
					align: "center",
					render: (h, params) => {
						return h("span", params.row.product.productModel);
					},
				},
				{
					prop: "brand",
					label: "品牌",
					align: "center",
					render: (h, params) => {
						return h(
							"span",
							this.$utils.escapeBrand(params.row.brand)
						);
					},
				},
				{
					prop: "online",
					label: "网络连接状态",
					align: "center",
					width: "120",
					render: (h, params) => {
						return h("span", params.row.online ? "在线" : "离线");
					},
				},
				{
					prop: "activeTime",
					label: "激活时间",
					align: "center",
					width: 200,
					sortable: true,
					render: (h, params) => {
						return h(
							"span",
							this.$utils.formatDate(params.row.activeTime)
						);
					},
				},
				{
					prop: "lastOnlineTime",
					label: "最新在线时间",
					align: "center",
					width: 200,
					sortable: true,
					render: (h, params) => {
						return h(
							"span",
							this.$utils.formatDate(params.row.lastOnlineTime)
						);
					},
				},
				{
					label: "操作",
					width: 200,
					align: "center",
					fixed: "right",
					operates: [
						{
							label: "查看",
							type: "primary",
							show: this.btnPer("/standardDevice/deviceDetail"),
							method: (index, row) => {
								this.handleDetail(row);
							},
						},
						{
							label: "删除",
							type: "primary",
							show: this.btnPer("sta_delDevice"),
							method: (index, row) => {
								this.handleDelete(row);
							},
						},
					],
				},
			],
			tableData: [],
			tableFilter: {
				pageNumber: 1,
				pageSize: 10,
			},
			total: 0,
		};
	},
	mounted() {
		this.getDeviceList();
		this.getProductModel();
	},
	components: {
		tablePage,
		pagination,
		search,
	},
	methods: {
		// 获取列表
		getDeviceList() {
			// 厨电类的 tagId 为 1
			let params = { ...this.tableFilter, ...this.searchParams, tagId: 1 };
			this.$http.chefDevicePage(params).then((res) => {
				if (res.data.success) {
					this.$set(this, "tableData", res.data.rows);
					this.$set(this, "total", res.data.total);
				}
			});
		},
		//获取产品型号
		getProductModel(e) {
			this.$http
				.productModuleAll({
					productTypeId: e,
				})
				.then((res) => {
					if (res.data.success) {
						this.productModels = res.data.data;
						let list = [];
						for (let i in res.data.data) {
							list[i] = {
								label: res.data.data[i].productModel,
								value: res.data.data[i].id,
							};
						}
						this.searchList[1].options = list;
					}
				});
		},
		// 查看
		handleDetail(raw) {
			this.$router.push("/standardDevice/deviceDetail?id=" + raw.id);
		},
		// 导出
		handleExport() {
			if (this.selectArry.length > 0) {
				this.$http.deviceExport().then((res) => {
					require.ensure([], () => {
						const {
							export_json_to_excel,
						} = require("../../../assets/js/Export2Excel");
						var tHeader = [],
							filterVal = [];
						this.columns.forEach((i) => {
							if (i.label != "操作") {
								tHeader.push(i.label);
								filterVal.push(i.prop);
							}
						});
						const list = Object.assign([], this.selectArry);
						list.forEach((item, index) => {
							item.productModel = item.product.productModel;
							for (var x in item) {
								if (x.indexOf("Time") != -1) {
									item[x] = this.$filters.dateFilter(
										item[x],
										""
									);
								}
								if (x == "online") {
									item[x] = item[x] ? "在线" : "离线";
								} else if (x == "init") {
									item[x] = item[x] ? "已激活" : "未激活";
								} else if (x == "product") {
									item[x] = item.productType.productType;
								}
							}
						});
						const data = this.formatJson(filterVal, list);
						export_json_to_excel(
							tHeader,
							data,
							"厨师机列表" + this.$utils.formatDate(new Date())
						);
					});
				});
			} else {
				Message.error("请至少选择一项");
			}
		},
		formatJson(filterVal, jsonData) {
			return jsonData.map((v) => filterVal.map((j) => v[j]));
		},
		handleSelectionChange(rows) {
			this.selectArry = JSON.parse(JSON.stringify(rows));
		},
		// 删除
		handleDelete(row) {
			this.$confirm(
				"<p style='margin-bottom:40px'>确认删除此设备吗？</p><p style='color:red;width:80%;position: absolute;top: 30px;'>删除此设备后，与此设备关联的用户都将失去该设备的控制权.</p>",
				"提示",
				{
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					dangerouslyUseHTMLString: true,
					type: "warning",
				}
			)
				.then(() => {
					this.$http.chefDeviceDelete(row.id).then((res) => {
						this.getDeviceList();
					});
				})
				.catch(() => {});
		},
		submitForm(formName) {
			if (formName == "searchParams") {
				if (this.searchParams.activeTime) {
					this.searchParams.activeStartTime = this.$utils.formatDate(
						this.searchParams.activeTime[0]
					);
					this.searchParams.activeEndTime = this.$utils.formatDate(
						this.searchParams.activeTime[1]
					);
					delete this.searchParams.activeTime;
				} else {
					this.searchParams.activeStartTime = null;
					this.searchParams.activeEndTime = null;
				}
				this.page = 1;
				this.limit = 10;
				this.getDeviceList();
			} else {
			}
		},
		resetForm(formName) {
			if (formName == "searchParams") {
				this.searchParams = {
					macSn: null,
					productId: null,
					online: null,
					activeTime: null,
				};
				this.getDeviceList();
			} else {
				this.$refs[formName].resetFields();
				this.dialogVisible = false;
			}
		},
		// 判断按钮权限
		btnPer: function (name) {
			let list = this.$store.state.standard.menuNodeList,
				flag = false;
			for (let i in list) {
				if (list[i].href == name) {
					flag = true;
					break;
				}
			}
			return flag;
		},
	},
};
</script>

<style scoped>
.actBar {
	display: block;
}
.searchBar {
	display: inline-block;
	vertical-align: top;
	width: calc(100% - 120px);
}
</style>
